import React from 'react';
import { inputArrowUpside } from 'static/icons/resizable';
import { IconPadded } from 'view/atoms/IconPadded';

export const CustomDropdownIndicatorUpside = () => {
  return (
    <IconPadded
      className='Select__dropdown-indicator'
      src={inputArrowUpside}
      alt='location'
      customStyles={{
        desktop: { padding: '6px' },
        mobile: { padding: '5px' },
      }}
    />
  );
};
